import { Table } from "@tanstack/react-table";
import { X } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import { DataTableViewOptions } from "./data-table-view-options";
import { DataTableFilter } from "./data-table-filter";

interface DataTableToolbarProps<TData> {
  table: Table<TData>;
  inputFilter?: boolean;
  inputPlaceholder?: string;
  filters?: Array<{
    column: string;
    title: string;
    options: Array<{ label: string; value: string }>;
  }>;
  hideViewOptions?: boolean;
}

export function DataTableToolbar<TData>({
  table,
  filters = [],
  hideViewOptions = false,
}: DataTableToolbarProps<TData>) {
  const { t } = useTranslation("common");
  const isFiltered = table.getState().columnFilters && table.getState().columnFilters.length > 0;

  return (
    <div className="flex items-center justify-between">
      <div className="flex flex-1 items-center gap-2">
        {filters.map(
          (filter) =>
            table.getColumn(filter.column) && (
              <DataTableFilter
                key={filter.column}
                column={table.getColumn(filter.column)}
                title={filter.title}
                options={filter.options}
              />
            ),
        )}
        {isFiltered && (
          <Button variant="ghost" size="sm" onClick={() => table.resetColumnFilters()}>
            {t("actions.resetFilters")}
            <X />
          </Button>
        )}
      </div>
      {hideViewOptions && (
        <div className="flex items-center gap-2">
          <DataTableViewOptions table={table} />
        </div>
      )}
    </div>
  );
}
